<template>
    <v-container>
      <v-row class="elevation-1">
        <v-col cols="6" lg="12">
          <v-btn
            id="create-new-fiscal-year"
            class="mx-2" color="primary"
            @click="openDialogbox"
          >
            Create New Fiscal Year
          </v-btn>
          <TaxPaymentCreateFiscalYearDialog
            :dialog="dialog"
            @dialogVal="setDialog"
          />
        </v-col>
      </v-row>
    </v-container>
</template>

<script>

import TaxPaymentCreateFiscalYearDialog from '../../../../components/tax/payments/createFiscalYear/taxPaymentCreateFY.vue';

export default {
  name: 'TaxPaymentCreateFiscalYear',
  components: {
    TaxPaymentCreateFiscalYearDialog,
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    openDialogbox() {
      this.dialog = true;
    },
    setDialog(val) {
      this.dialog = val;
    },
  },
};
</script>
